export const REGULAR_IN_REM = '1rem';
